import { SETTINGS_ENABLE_CONSTRUCTOR_TEMPLATES_SLUG } from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsConstructorTemplatesEnabled = () => {
    const settings = useSettingsFactory({
        settingsConstructorTemplatesEnabled: {
            path: SETTINGS_ENABLE_CONSTRUCTOR_TEMPLATES_SLUG,
        },
    });

    return {
        ...settings,
        values: {
            settingsConstructorTemplatesEnabled: {
                ...settings.values.settingsConstructorTemplatesEnabled,
                value: true,
            },
        },
    };
};
